import { useQuery } from "@tanstack/react-query";
import Loading from "../../../../components/Loading";
import { getRequestByAuth } from "../../../../function/helper";
import OrderDetailsVariantsTable from "./OrderDetailsVariantsTable";
import OrderForm from "./OrderForm";

export default function OrderDetailsModal({
  getSellerData,
  order,
  onClose,
  messages,
  refetch,
}) {
  const { isFetching, data: postData } = useQuery({
    queryKey: ["getDigikalaShipPostData" + String(order?.shipmentId)],
    queryFn: () =>
      getRequestByAuth(
        `/v2/digikala/getDigikalaShipPostData/${order?.shipmentId}`
      ).then(res => {
        if (res && res.status === 200) return res.data || res.data?.data || {};
        return Promise.reject(
          new Error(res?.message || "خطا در دریافت اطلاعت مرسوله دیجی کالا")
        );
      }),
    gcTime: 60 * 60 * 1000,
    staleTime: 60 * 60 * 1000,
    retry: 0,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  if (!order) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex={-1}
      role="dialog"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl container container-custom"
        role="document"
      >
        <div className="modal-content" style={{ direction: "ltr" }}>
          <div className="modal-header">
            <h5 className="modal-title">جزییات سفارش {order.orderId}</h5>
          </div>
          {isFetching && <Loading className="h-25" />}

          {!isFetching && (
            <>
              <div className="modal-body" style={{ overflow: "auto" }}>
                <OrderDetailsVariantsTable order={order} />
                {order.status?.text === "processing" && (
                  <OrderForm
                    onClose={onClose}
                    getSellerData={getSellerData}
                    order={order}
                    postData={postData}
                    refetch={() => {
                      refetch();
                    }}
                  />
                )}

                <div className="text-start mt-2">
                  {messages && (
                    <div dangerouslySetInnerHTML={{ __html: messages }} />
                  )}
                </div>
              </div>

              <div className="modal-footer flex flex-wrap p-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  لغو
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
